/* eslint-disable jsx-a11y/media-has-caption */

import React from "react";

import { Trans } from "app/utils";
import { Icon, PlainButton, Thumbnail } from "@culturehq/components";

import linkedin from "images/social/linkedin.svg";

import LinkedinReactionIcon from "components/linkedin/LinkedinReactionIcon";
import LinkedinReactionText from "components/linkedin/LinkedinReactionText";
import Subtitles from "components/common/Subtitles";
import LinkedinMentionText from "components/linkedin/LinkedinMentionText";
import getUserName from "app/utils/getUserName";

const LinkedinPreview = ({
  mediaRef,
  showVideoInfo,
  onShowVideoInfo,
  onPlay,
  imageUrl,
  data,
  profile,
  socialPostType,
  shareMessage,
  story
}) => {
  const getAccountImage = () => {
    if (socialPostType === "business") {
      return data.author.logoV2["original~"].elements[0].identifiers[0].identifier;
    }
    return profile.avatar.thumbUrl;
  };

  const getAccountText = () => {
    if (socialPostType === "business") {
      return data.author.localizedName;
    }
    if (socialPostType === "personal") {
      return `${data.author.linkedinProfile.localizedFirstName} ${data.author.linkedinProfile.localizedLastName}`;
    }
    return getUserName(profile);
  };

  return (
    <>
      <div className="Body_Header Preview-User">
        <div className="Preview-User__Info-Container">
          <Thumbnail className="Thumbnail" image={getAccountImage()} title={data?.author?.label || getUserName(profile)} />
          <div>
            <p className="Preview-User__Info Preview-User__Info-Name">{getAccountText()}</p>
          </div>
        </div>
        <img className="social-icon" src={linkedin} alt="LinkedIn" />
      </div>
      <div className="Preview-area no-scrollbar">
        <LinkedinMentionText value={data?.text || shareMessage} />
      </div>
      <div className="gallery-lightbox__photo">
        <div className="gallery-lightbox__image-container" style={{ backgroundImage: `url(${imageUrl})` }} />
        {story.media.mediaType === "image" && (
          <img
            className="gallery-lightbox__photo--image"
            ref={mediaRef}
            src={imageUrl}
            alt={story.imageAlt || story.question.question}
          />
        )}
        {story.media.mediaType === "video" && (
          <>
            {showVideoInfo && (
              <div className="gallery-lightbox__video-play" onClick={onPlay}><Icon icon="play-filled" /></div>
            )}
            <video
              controls
              className="gallery-lightbox__main-image gallery-lightbox__main-video"
              onPause={() => onShowVideoInfo(true)}
              onPlay={() => onShowVideoInfo(false)}
              poster={`${story.media.thumbnail}?not-from-cache-please`}
              ref={mediaRef}
              src={story.media.url}
              disablePictureInPicture
              crossOrigin="anonymous"
              controlsList="nodownload"
            >
              <Subtitles media={story.media} />
            </video>
          </>
        )}
      </div>
      <div className="Preview-Actions">
        <PlainButton className="Linkedin-Reactions__Btn">
          <LinkedinReactionIcon />
          <LinkedinReactionText />
        </PlainButton>
        <PlainButton>
          <Icon icon="linkedin-comment" />
          <Trans>Comment</Trans>
        </PlainButton>
        <PlainButton>
          <Icon icon="linkedin-share" />
          <Trans>Share</Trans>
        </PlainButton>
      </div>
    </>
  );
};

export default LinkedinPreview;
